import "./app.css";
import { Formio } from "@formio/react";
import FormioContrib from "@formio/contrib";
// import Navigation from "./components/Navigation";
import { Route, Routes } from "react-router-dom";
// import Home from "./components/Home";
import Builder from "./components/Builder";
// import Components from "./components/Components";

Formio.use(FormioContrib);

function App() {
  return (
    <div className="App">
      {/* <Navigation /> */}
      {/* <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/" element={<Components />}></Route>
      </Routes> */}
      <Builder />
    </div>
  );
}

export default App;
